module.exports = __webpack_public_path__ + "static/media/mercado-modelo-cartao-visita.60fcbc3f.jpg";